import {logger} from 'tizra'
import {SsoSignIn, SsoSignInProps} from './SsoSignIn'
import {TizraSignIn, TizraSignInProps} from './TizraSignIn'

const log = logger('AuthSignIn')

interface AuthSignInProps extends Omit<TizraSignInProps, 'authAgent'> {
  authAgent: TizraSignInProps['authAgent'] | SsoSignInProps['authAgent']
}

export const AuthSignIn = ({authAgent, ...props}: AuthSignInProps) => {
  const resolvedAuthAgent =
    authAgent !== 'custom' ? authAgent
    : typeof window === 'undefined' || !window.tizra?.customLoginUrl ?
      'internal'
    : 'custom'

  return resolvedAuthAgent === 'sso' || resolvedAuthAgent === 'custom' ?
      <SsoSignIn {...props} authAgent={resolvedAuthAgent} />
    : <TizraSignIn {...props} authAgent={resolvedAuthAgent} />
}
